import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';
import { PaymentMethodType } from '@/modules/user/user.types';

const PAYMENT_METHOD_TITLE: Record<string, string> = {
  [PaymentMethodType.DIRECT_DEPOSIT]: 'Direct Deposit',
  [PaymentMethodType.DEBIT]: 'My Personal Debit Card',
  [PaymentMethodType.VENMO]: 'Venmo',
  [PaymentMethodType.PAYPAL]: 'PayPal',
  [PaymentMethodType.CHECK]: 'Check',
};

export const getPaymentMethodTitle = (method: PaymentMethod): string => {
  if (method.type === PaymentMethodType.DIRECT_DEPOSIT) {
    return `Direct Deposit (${method.accountNumberLast4 || '****'})`;
  }
  if (method.type === PaymentMethodType.DEBIT) {
    const brand = method.requisites?.cardType
      ? method.requisites.cardType.charAt(0).toUpperCase() + method.requisites.cardType.slice(1).toLowerCase()
      : 'Debit Card';
    return `${brand} (${method.requisites?.cardLast4 || '****'})`;
  }
  if (method.type === PaymentMethodType.PAYPAL) {
    return method.requisites?.email || method.requisites?.phoneNumber || 'PayPal';
  }
  if (method.type === PaymentMethodType.VENMO) {
    return method.requisites?.phoneNumber || 'Venmo';
  }
  if (method.type === PaymentMethodType.CHECK) {
    return 'Check';
  }
  return PAYMENT_METHOD_TITLE[method.type || ''] || 'Payment Method';
};
